export {}

if (typeof Array.prototype.flatMap !== 'function') {
  // [B](f: (A) ⇒ [B]): [B]  ; Although the types in the arrays aren't strict (:
  Array.prototype.flatMap = function(lambda) {
    return Array.prototype.concat.apply([], this.map(lambda));
  };
}